const jwtDecode = require('jwt-decode');

const errorHandler = (dispatch, err) => {
  console.log(err);
  switch (err.code) {
    case 'domain:authUser:validateOAuth2':
      dispatch('AUTH:DOMAIN', err);
      break;
    case 'no-permission:authUser:getPermission':
      dispatch('AUTH:AUTHORIZATION', err);
      break;
    default:
      dispatch('AUTH:SYSTEM_ERROR', err);
      break;
  }
}

const Thunk = {

  auth_user: (firebase, dispatch, id_token) => {
    // const ROUTE = "http://localhost:5005/lop-phhs/us-central1/authUser";
    const ROUTE = "https://us-central1-lop-phhs.cloudfunctions.net/authUser";
    fetch(ROUTE, {
      method: "POST",
      mode: 'cors',
      cache: 'no-cache',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({id_token})
    })
      .then(response => response.json())
      .then(authToken => {
        if (authToken.err) {
          errorHandler(dispatch, authToken)
        } else {
          firebase.auth().signInWithCustomToken(authToken.payload).catch(function(error) {
            // Handle Errors here.
            errorHandler(dispatch, {err: true, code: 'firebase-signin', message: 'Unable to sign in to Firebase with provided token'})
            console.log(error);
          }).then(fbResult => {
            firebase.auth().currentUser.getIdTokenResult().then(r => {
              console.log("*** IdTokenResult ***")
              console.log(r);
              console.log("*** Claims ***")
              console.log(JSON.stringify(r.claims));
            })
            var claims = null;
            try {
              claims = jwtDecode(authToken.payload).claims;
              dispatch('AUTH:SUCCESS', {id_token: authToken.payload, ...claims});
            } catch (e) {
              errorHandler(dispatch, {err: true, code: 'token-error', message: 'Invalid JWT returned from Firebase'})
            }
          });
        }
      })
      .catch(err => {
        console.log(err);
        errorHandler(dispatch, err);
      })
  },

  // get_student_list: (dispatch, id_token) => {
  //   return Api({
  //     route: 'get/students',
  //     id_token: id_token
  //   })
  //     .then(data => {
  //       let studentList = data.rows;
  //       studentList = R.map(s => ({
  //         name: s.last_name+', '+s.first_name+' ('+s.grade+' | '+s.class_of+')',
  //         student_id: s.student_id
  //       }), studentList);
  //       studentList = R.sort((a,b) => (a.name < b.name) ? -1 : 1, studentList);
  //       dispatch('DATA:STUDENT_LIST', studentList)
  //     })
  //     .catch(err => {

  //     })
  // },

  // get_school_list: () => {
  //   return (dispatch, getState) => {
  //     let opt = {
  //       id_token: getState().auth.get('id_token'),
  //       route: 'query/getSchools'
  //     }
  //     if (!getState().user.get('allSchools')) {
  //       opt.data = {schoolid: getState().user.get('school_list')}
  //     }
  //     return Api(opt, dispatch)
  //       .then(schoolList => {
  //         let schoolsSelected = getState().pages.getIn(['profileGrid','selectedSchoolList'])
  //         if (schoolList.length > 0 && (schoolsSelected.length === 0)) {
  //           dispatch(ActionCreator(AC.PAGES_PROFILE_GRID_ADD_REMOVE_SCHOOL, {schoolId: schoolList[0].schoolId+''}))
  //         }
  //         dispatch(ActionCreator(AC.DATA_SET_SCHOOL_LIST, {schoolList}))
  //         dispatch(Thunk.get_student_list())
  //       })
  //       .catch(err => {
  //         dispatch(ActionCreator(AC.API_FAILURE))
  //       })
  //   }
  // },
  //
  // get_student_list: () => {
  //   return (dispatch, getState) => {
  //     let schoolList = getState().pages.getIn(['profileGrid','selectedSchoolList'])
  //     if (schoolList.length === 0) {
  //       dispatch(ActionCreator(AC.DATA_SET_STUDENT_LIST, {studentList: []}))
  //     } else {
  //       let filter = getState().filter.toJS()
  //       let apiData = {
  //         route: 'query/getPsStudentNames',
  //         id_token: getState().auth.get('id_token'),
  //         data: {
  //           schoolid: getState().pages.getIn(['profileGrid','selectedSchoolList']),
  //           filterValues: {
  //             ca_counselor: filter.counselor,
  //             grade_level: filter.grade,
  //             class_of: filter.classOf,
  //             lastNameFrom: filter.lastNameFrom,
  //             lastNameTo: filter.lastNameTo,
  //             gpaGreaterThan: filter.gpaGreaterThan,
  //             gpaLessThan: filter.gpaLessThan,
  //             filterText: '',
  //             tags: filter.tags,
  //             email: getState().user.get('email')
  //           }
  //         }
  //       }
  //       return Api(apiData, dispatch)
  //         .then(data => {
  //           let studentList = (data.error) ? [] : data
  //           dispatch(ActionCreator(AC.DATA_SET_STUDENT_LIST, {studentList}))
  //         })
  //         .catch(err => {
  //           dispatch(ActionCreator(AC.DATA_SET_STUDENT_LIST, {studentList: []}))
  //           dispatch(ActionCreator(AC.API_FAILURE))
  //         })
  //     }
  //   }
  // },
  //
  // data_setCourseList: function() {
  //   return (dispatch, getState) => {
  //     return Api({
  //       id_token: getState().auth.get('id_token'),
  //       route: 'query/getCourseList'
  //     }, dispatch)
  //       .then(data => {
  //         dispatch(ActionCreator(AC.DATA_SET_COURSE_LIST, {courseList: data}))
  //       })
  //       .catch(err => {
  //         dispatch(ActionCreator(AC.API_FAILURE))
  //       })
  //   }
  // },
  //
  // data_setCounts: function(table) {
  //   return (dispatch, getState) => {
  //     return Api({
  //       id_token: getState().auth.get('id_token'),
  //       route: 'query/getCourseCounts',
  //       data: {table: table}
  //     }, dispatch)
  //       .then(data => {
  //         dispatch(ActionCreator(AC.DATA_SET_COUNTS, {
  //           table: table,
  //           countList: data
  //         }))
  //       })
  //       .catch(err => {
  //         dispatch(ActionCreator(AC.API_FAILURE))
  //       })
  //   }
  // },
  //
  // courses_saveCourseInformation: (id, subject, rc, ur) => {
  //   return function (dispatch, getState) {
  //     let apiData = {
  //       route: 'update/setCourseInformation',
  //       id_token: getState().auth.get('id_token'),
  //       data: {
  //         id,
  //         subject,
  //         requirement_code: rc,
  //         under_review: ur
  //       }
  //     }
  //     return Api(apiData, dispatch)
  //       .then(data => {
  //         dispatch(Thunk.data_setCourseList())
  //       })
  //       .catch(err => {
  //         dispatch(ActionCreator(AC.API_FAILURE))
  //       })
  //   }
  // },
  //
  // pages_profileGrid_changeFilter: (property, newValue) => {
  //   return (dispatch, getState) => {
  //     dispatch(ActionCreator(AC.PAGES_PROFILE_GRID_CHANGE_FILTER, {filterObj: {[property]: newValue} }))
  //     dispatch(Thunk.get_student_list())
  //   }
  // },
  //
  // pages_profileGrid_setAtRiskConfigList: (id) => {
  //   return (dispatch, getState) => {
  //     dispatch(ActionCreator(AC.PAGES_PROFILE_GRID_SET_AT_RISK_CONFIG_LIST, {id}))
  //     let selectedId = getState().pages.getIn(['atRiskConfiguration','selectedConfigId'])
  //     if (selectedId !== null) {
  //       if (selectedId < 0) {
  //         let bySdusd = require('sdusd-osps4-constants').SDUSD_AT_RISK
  //         let found = R.find(item => item.id + '' === selectedId + '', bySdusd)
  //         dispatch(ActionCreator(AC.DATA_SET_AT_RISK_CONFIGURATION, {atRiskConfiguration: found}))
  //         return null
  //       } else {
  //         let apiData = {
  //           route: 'query/getAtRiskConfiguration',
  //           id_token: getState().auth.get('id_token'),
  //           data: {
  //             id: selectedId,
  //           }
  //         }
  //         return Api(apiData, dispatch)
  //           .then(data => {
  //             let $selectedAtRiskConfig = null
  //             if (!data.error && data.length > 0) {
  //               $selectedAtRiskConfig = R.head(data)
  //               $selectedAtRiskConfig.config = JSON.parse($selectedAtRiskConfig.json)
  //             }
  //             dispatch(ActionCreator(AC.DATA_SET_AT_RISK_CONFIGURATION, {atRiskConfiguration: $selectedAtRiskConfig}))
  //           })
  //           .catch(err => {
  //             dispatch(ActionCreator(AC.DATA_SET_AT_RISK_CONFIGURATION, {atRiskConfiguration: null}))
  //           })
  //       }
  //     }
  //   }
  // },
  //
  // pages_profileGrid_setAtRiskConfigSettings: (arc) => {
  //   return function(dispatch, getState) {
  //     if (arc.id >= 0) {
  //       Api({
  //         route: 'update/setAtRiskConfiguration',
  //         id_token: getState().auth.get('id_token'),
  //         data: {...arc}
  //       }, dispatch)
  //         .then(data => {
  //           dispatch(Thunk.data_setAtRiskConfiguration())
  //         })
  //         .catch(err => {
  //           dispatch(ActionCreator(AC.API_FAILURE))
  //         })
  //     }
  //   }
  // },
  //
  // pages_profileGrid_studentSelected: (studentNumber) => {
  //   return (dispatch, getState) => {
  //     dispatch(ActionCreator(AC.PAGES_PROFILE_GRID_STUDENT_SELECTED, {studentNumber}))
  //     dispatch(Thunk.data_setStudent())
  //     dispatch(Thunk.data_setStudentNotes())
  //     dispatch(Thunk.data_setStudentSchedule())
  //   }
  // },
  //
  // data_setStudentSchedule: function() {
  //   return (dispatch, getState) => {
  //     let newState = getState()
  //     let selectedStudentNumber = newState.pages.getIn(['profileGrid','selectedStudentNumber'])
  //     if (selectedStudentNumber === null || selectedStudentNumber === undefined) {
  //       dispatch(ActionCreator(AC.DATA_SET_STUDENT_SCHEDULE, {student: null}))
  //       return null
  //     } else {
  //       // Get student schedule data first
  //       let apiData = {
  //         route: 'query/getPsSchedule',
  //         id_token: newState.auth.get('id_token'),
  //         data: {
  //           student_number: selectedStudentNumber
  //         }
  //       }
  //       return Api(apiData, dispatch)
  //         .then(data => {
  //           if (data.length > 0) {
  //             dispatch(ActionCreator(AC.DATA_SET_STUDENT_SCHEDULE, {studentSchedule: data}))
  //           }
  //         })
  //         .catch(error => {
  //           console.log(error)
  //           dispatch(ActionCreator(AC.DATA_SET_STUDENT_SCHEDULE, {student: null}))
  //           dispatch(ActionCreator(AC.API_FAILURE))
  //         })
  //     }
  //   }
  // },
  //
  // data_setStudent: function() {
  //   return (dispatch, getState) => {
  //     let newState = getState()
  //     let selectedStudentNumber = newState.pages.getIn(['profileGrid','selectedStudentNumber'])
  //     if (selectedStudentNumber === null || selectedStudentNumber === undefined) {
  //       dispatch(ActionCreator(AC.DATA_SET_STUDENT, {student: null}))
  //       return null
  //     } else {
  //       // Get student data first
  //       let apiData = {
  //         route: 'query/getPsStudent',
  //         id_token: newState.auth.get('id_token'),
  //         data: {
  //           id: newState.pages.getIn(['profileGrid','selectedStudentNumber'])
  //         }
  //       }
  //       return Api(apiData, dispatch)
  //         .then(data => {
  //           if (data.length > 0) {
  //             let student = (data[0])
  //             if (student) {
  //               student.details = JSON.parse(student.json)
  //               student.ccte = JSON.parse(student.json_ccte);
  //               dispatch(ActionCreator(AC.DATA_SET_STUDENT, {student}))
  //             } else {
  //               dispatch(ActionCreator(AC.DATA_SET_STUDENT, {student: null}))
  //             }
  //           }
  //         })
  //         .catch(error => {
  //           console.log(error)
  //           dispatch(ActionCreator(AC.DATA_SET_STUDENT, {student: null}))
  //           dispatch(ActionCreator(AC.API_FAILURE))
  //         })
  //     }
  //   }
  // },
  //
  // data_setStudentNotes: function() {
  //   return (dispatch, getState) => {
  //     let newState = getState()
  //     let selectedStudentNumber = newState.pages.getIn(['profileGrid','selectedStudentNumber'])
  //     if (selectedStudentNumber === null || selectedStudentNumber === undefined) {
  //       dispatch(ActionCreator(AC.DATA_SET_STUDENT, {student: null}))
  //       return null
  //     } else {
  //       // Get student notes too
  //       let apiNotesData = {
  //         route: 'query/getPsStudentNotes',
  //         id_token: newState.auth.get('id_token'),
  //         data: {
  //           id: newState.pages.getIn(['profileGrid','selectedStudentNumber'])
  //         }
  //       }
  //       return Api(apiNotesData, dispatch)
  //         .then(data => {
  //           if (data.length > 0) {
  //             let studentNotes = (data[0])
  //             if (studentNotes) {
  //               dispatch(ActionCreator(AC.DATA_SET_STUDENT_NOTES, {studentNotes}))
  //             } else {
  //               dispatch(ActionCreator(AC.DATA_SET_STUDENT_NOTES, {studentNotes: null}))
  //             }
  //           } else {
  //             dispatch(ActionCreator(AC.DATA_SET_STUDENT_NOTES, {studentNotes: null}))
  //           }
  //         })
  //         .catch(error => {
  //           console.log(error)
  //           dispatch(ActionCreator(AC.DATA_SET_STUDENT_NOTES, {studentNotes: null}))
  //           dispatch(ActionCreator(AC.API_FAILURE))
  //         })
  //     }
  //   }
  // },
  //
  // data_saveStudentNotes: function(notes) {
  //   return (dispatch, getState) => {
  //     let newState = getState()
  //     return Api({
  //       route: 'update/setStudentNotes',
  //       id_token: newState.auth.get('id_token'),
  //       data: {
  //         id: notes.id,
  //         student_number: notes.student_number,
  //         notes: notes.notes,
  //         dl_notes: notes.dl_notes
  //       }
  //     })
  //       .then(data => {
  //         dispatch(Thunk.data_setStudentNotes())
  //       })
  //       .catch(err => {
  //         dispatch(ActionCreator(AC.API_FAILURE))
  //       })
  //   }
  // },
  //
  // data_setAtRiskConfiguration: function() {
  //   return (dispatch, getState) => {
  //     let id = getState().pages.getIn(['atRiskConfiguration','selectedConfigId'])
  //     if (id !== null) {
  //       dispatch(Thunk.pages_profileGrid_setAtRiskConfigList(id))
  //     }
  //   }
  // },
  //
  // settings_get: function() {
  //   return (dispatch, getState) => {
  //     let apiData = {
  //       route: 'query/getSettings',
  //       id_token: getState().auth.get('id_token'),
  //       data: {
  //         email: getState().user.get('email')
  //       }
  //     }
  //     return Api(apiData, dispatch)
  //       .then(data => {
  //         if (data.length > 0) {
  //           let settings = data[0]
  //           if (settings) {
  //             settings.tags = R.split(',', settings.tags)
  //             dispatch(ActionCreator(AC.SETTINGS_SET, {...settings}))
  //           }
  //         }
  //       })
  //       .catch(error => {
  //         console.log(error)
  //         dispatch(ActionCreator(AC.API_FAILURE))
  //       })
  //   }
  // },
  //
  // settings_set: function(newSettings) {
  //   return (dispatch, getState) => {
  //     let apiData = {
  //       route: 'update/setSettings',
  //       id_token: getState().auth.get('id_token'),
  //       data: {...newSettings}
  //     }
  //     return Api(apiData, dispatch)
  //       .then(data => {
  //         dispatch(Thunk.settings_get())
  //       })
  //       .catch(error => {
  //         console.log(error)
  //         dispatch(ActionCreator(AC.API_FAILURE))
  //       })
  //   }
  // },
  //
  // auth_getSavedAppState: function() {
  //   return (dispatch, getState) => {
  //     let appStateJSON = localStorage.getItem(getState().user.get('email'))
  //     let appState = JSON.parse(appStateJSON)
  //     if (appState) {
  //       dispatch(ActionCreator(AC.APP_RESTORE_STATE, {...appState}))
  //       let selectedStudentNumber = getState().pages.get('profileGrid').selectedStudentNumber
  //       if (selectedStudentNumber.length > 0) {
  //         dispatch(Thunk.pages_profileGrid_studentSelected(selectedStudentNumber))
  //       }
  //     }
  //     dispatch(ActionCreator(AC.AUTH_CHECKED_SAVED_STATE))
  //   }
  // }
  //
}

export default Thunk



// WEBPACK FOOTER //
// ./src/store/Thunk.js